import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { icon } from './icon.vanilla.mjs';

function IndeterminateIcon({
  className: classNameFromProps,
  ...props
}) {
  const className = classNames(icon, classNameFromProps);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-scope": "checkbox",
      "data-part": "indeterminate-icon",
      "data-checkbox-icon": "",
      className,
      width: "10",
      height: "2",
      viewBox: "0 0 10 2",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: /* @__PURE__ */ jsx("path", { d: "M0 1H10", stroke: "white", strokeWidth: "2" })
    }
  );
}

export { IndeterminateIcon };
//# sourceMappingURL=IndeterminateIcon.mjs.map
